module.exports = __webpack_public_path__ + "img/05-innovation-technology.be911e5b.png";